import {useIsFetching, useIsMutating} from '@tanstack/react-query';
import {useEffect, useState} from 'react';
import app from '@src/helpers/app';
import {HttpEvents} from '@src/@types/services/Http/Http';

export default function useIsLoading() {
    const isFetching = useIsFetching();
    const isMutating = useIsMutating();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const subscription = app('http').listen([
            HttpEvents.BEFORE_SEND_REQUEST,
            HttpEvents.REQUEST_COMPLETED,
        ], (event) => {
            setIsLoading(event.name === HttpEvents.BEFORE_SEND_REQUEST);
        });

        return () => subscription.unsubscribe();
    }, []);

    return isFetching || isMutating || isLoading;
}
